webpackJsonp([97372981751318],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _MarkdownPage = __webpack_require__(34);
	
	var _MarkdownPage2 = _interopRequireDefault(_MarkdownPage);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createLink = __webpack_require__(21);
	
	var _sectionList = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Community = function Community(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  return Glamor.createElement(_MarkdownPage2.default, {
	    createLink: _createLink.createLinkCommunity,
	    location: location,
	    markdownRemark: data.markdownRemark,
	    sectionList: _sectionList.sectionListCommunity,
	    titlePostfix: ' \u2013 AviaCommerce'
	  });
	}; /**
	    * Copyright (c) 2015-present, Aviabird
	    *
	    * @emails avia-core
	    */
	
	Community.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	// eslint-disable-next-line no-undef
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Community;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-community-js-532737daf0362a8e5c82.js